import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const MoreStory = (props) => {
  const { match } = props;

  return <ListStory page={Number(match.params.page)} type="topstories" />;
};

export default MoreStory;
